// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"271":"70daa05b","381":"5f96cdd2","468":"344b9437"}[chunkId] + ".chunk.js";
};